import { Action } from "../../actions/Action";
import { gameData } from "../../GameManager";
import { Actor } from "../Actor";

export enum TraitPriorties {
  LOWEST = 0.1,
  BASE_MOVE = 0.3,
  AVERAGE = 0.5,
  EXTREME = 0.9,
  MANDATORY = 1.0,
}

export type AITraits<T> = {
  max: number;
  getPriority: (actor: Actor) => [number, T];
  getAction: (actor: Actor, data: T) => Action<any>;
};

export const updateSeen = (actor: Actor) => {
  const visible = true;
  if (visible) {
    actor.aiProps.seenPlayer = 10; //Turns the monster will chase enemy out of line of sight
  } else if (actor.aiProps.seenPlayer) {
    actor.aiProps.seenPlayer -= 1;
  }
  return visible;
};
